import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_user_role",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "User Information")
], -1)
const _hoisted_9 = { class: "row mb-7" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Email:", -1)
const _hoisted_11 = { class: "col-lg-7 fv-row" }
const _hoisted_12 = { class: "fw-bold fs-6" }
const _hoisted_13 = { class: "row mb-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Phone:", -1)
const _hoisted_15 = { class: "col-lg-7 fv-row" }
const _hoisted_16 = { class: "fw-bold fs-6" }
const _hoisted_17 = { class: "row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "User Type:", -1)
const _hoisted_19 = { class: "col-lg-7 fv-row" }
const _hoisted_20 = { class: "fw-bold fs-6 text-uppercase" }
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Registered Date:", -1)
const _hoisted_23 = { class: "col-lg-7 fv-row" }
const _hoisted_24 = { class: "fw-bold fs-6" }
const _hoisted_25 = { class: "d-flex flex-column mb-2 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" })
], -1)
const _hoisted_27 = { class: "d-flex flex-stack mb-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Super Admin")
], -1)
const _hoisted_29 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, "Yes", -1)
const _hoisted_31 = { class: "d-flex flex-stack mb-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Admin")
], -1)
const _hoisted_33 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, "Yes", -1)
const _hoisted_35 = { class: "d-flex flex-stack mb-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Faculty")
], -1)
const _hoisted_37 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, "Yes", -1)
const _hoisted_39 = { class: "d-flex flex-stack mb-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Irb Chair")
], -1)
const _hoisted_41 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, "Yes", -1)
const _hoisted_43 = { class: "d-flex flex-stack mb-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Irb member")
], -1)
const _hoisted_45 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, "Yes", -1)
const _hoisted_47 = { class: "d-flex flex-stack mb-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Staff")
], -1)
const _hoisted_49 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, "Yes", -1)
const _hoisted_51 = { class: "d-flex flex-stack mb-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Student")
], -1)
const _hoisted_53 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-muted" }, "Yes", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentUserEdit.piEmail), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.currentUserEdit.piPhoneNumber), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.currentUserEdit.piRole), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.moment(_ctx.currentUserEdit.createdDate)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("label", _hoisted_29, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  name: "superAdmin",
                  type: "checkbox",
                  value: "1",
                  modelValue: _ctx.superAdmin,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.superAdmin) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCheckbox('superadmin', _ctx.superAdmin)))
                }, null, 8, ["modelValue"]),
                _hoisted_30
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("label", _hoisted_33, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  name: "admin",
                  type: "checkbox",
                  value: "1",
                  modelValue: _ctx.admin,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.admin) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeCheckbox('admin', _ctx.admin)))
                }, null, 8, ["modelValue"]),
                _hoisted_34
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("label", _hoisted_37, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  name: "faculty",
                  type: "checkbox",
                  value: "1",
                  modelValue: _ctx.faculty,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.faculty) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeCheckbox('faculty', _ctx.faculty)))
                }, null, 8, ["modelValue"]),
                _hoisted_38
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("label", _hoisted_41, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  name: "irbchair",
                  type: "checkbox",
                  value: "1",
                  modelValue: _ctx.irbchair,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.irbchair) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeCheckbox('irbchair', _ctx.irbchair)))
                }, null, 8, ["modelValue"]),
                _hoisted_42
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("label", _hoisted_45, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  name: "irbmember",
                  type: "checkbox",
                  value: "1",
                  modelValue: _ctx.irbmember,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.irbmember) = $event)),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeCheckbox('irbmember', _ctx.irbmember)))
                }, null, 8, ["modelValue"]),
                _hoisted_46
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("label", _hoisted_49, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  name: "staff",
                  type: "checkbox",
                  value: "1",
                  modelValue: _ctx.staff,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.staff) = $event)),
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeCheckbox('staff', _ctx.staff)))
                }, null, 8, ["modelValue"]),
                _hoisted_50
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("label", _hoisted_53, [
                _createVNode(_component_Field, {
                  class: "form-check-input",
                  name: "staff",
                  type: "checkbox",
                  value: "1",
                  modelValue: _ctx.student,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.student) = $event)),
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeCheckbox('student', _ctx.student)))
                }, null, 8, ["modelValue"]),
                _hoisted_54
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}